export default __webpack_public_path__ + "static/media/paymentFail.1e61485c.svg";